import { DataType } from "@dndModels/Types";
import { ColorsType } from "../DandDPalette";
import { PlayerObject } from "@models/UpsertableBase";

export class User extends PlayerObject {
  data_type: DataType = "user";
  auth_id = "";
  email = "";
  dm = false;
  admin = false;
  is_admin = false;
  campaign_ids: string[] = []; 
  // _ids of all source_books that they have access to
  purchased_sb_ids: string[] = [];
  shared_sb_ids: string[] = []; 
  free_sb_ids: string[] = []; 
  name = "";
  view_blocked_source_books = false;
  hide_info: string[] = [];
  profile_name = "";

  get use_name() {
    if (this.profile_name === "") {
      return this.name;
    } else {
      return this.profile_name;
    }
  }

  get source_book_ids() {
    return [...this.purchased_sb_ids, ...this.shared_sb_ids,...this.free_sb_ids];
  }
  
  colors_for: {
    [for_id: string]: ColorsType
  } = {};

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.auth_id = obj.auth_id ? obj.auth_id : "";
      this.email = obj.email ? obj.email : "";
      this.name = obj.name ? obj.name : (obj.username ? obj.username : "");
      this.profile_name = obj.profile_name ? obj.profile_name : "";
      this.dm = obj.dm ? obj.dm : false;
      this.is_admin = obj.is_admin ? obj.is_admin : (obj.admin ? obj.admin : false);
      this.admin = this.is_admin; // Comment for deploys.
      this.purchased_sb_ids = obj.purchased_sb_ids ? obj.purchased_sb_ids : [];
      this.campaign_ids = obj.campaign_ids ? obj.campaign_ids : [];
      this.shared_sb_ids = []; 
      this.view_blocked_source_books = obj.view_blocked_source_books ? obj.view_blocked_source_books : false;
      this.colors_for = obj.colors_for ? obj.colors_for : {};
      this.hide_info = obj.hide_info ? obj.hide_info : [];
    }
  }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      auth_id: this.auth_id,
      email: this.email,
      name: this.name,
      profile_name: this.profile_name,
      dm: this.dm,
      admin: this.is_admin,
      campaign_ids: this.campaign_ids,
      purchased_sb_ids: this.purchased_sb_ids,
      // shared_sb_ids: this.shared_sb_ids,
      colors_for: this.colors_for,
      view_blocked_source_books: this.view_blocked_source_books,
      hide_info: this.hide_info,
    };
  }

  copy(copyMe: User, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.auth_id = copyMe.auth_id;
    this.email = copyMe.email;
    this.name = copyMe.name;
    this.profile_name = copyMe.profile_name;
    this.dm = copyMe.dm;
    this.admin = copyMe.admin;
    this.is_admin = copyMe.is_admin;
    this.campaign_ids = [...copyMe.campaign_ids];
    this.purchased_sb_ids = [...copyMe.purchased_sb_ids];
    this.shared_sb_ids = [...copyMe.shared_sb_ids];
    this.colors_for = {...copyMe.colors_for}; 
    this.view_blocked_source_books = copyMe.view_blocked_source_books;
    this.hide_info = [...copyMe.hide_info];
  }

  clone(drop_ids = false): User {
    const new_obj = new User();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}